import http from '../../../utils/fetch';
export default {

    baseurl:'/api/swyl/v1/demo/bscActivityInfo',
    //分页查询
    selectPage(f) {
        return http({
            url: this.baseurl+'/selectPage',
            method: 'post',
            params: f
        });
    },


    selectById(id) {
        return http({
            url: this.baseurl+'/selectById',
            method: 'post',
            params: {id:id}
        });
    },


    deleteById(id) {
        return http({
            url: this.baseurl+'/deleteById',
            method: 'post',
            params:{id:id}
        });
    },

    insert(f) {
        return http({
            url: this.baseurl+'/insert',
            method: 'post',
            data: f
        });
    },

    updateById(f) {
        return http({
            url: this.baseurl+'/updateById',
            method: 'post',
            data: f
        });
    },


    selectCompanyList(usercodename) {
        return http({
            url: this.baseurl+'/selectCompanyList',
            method: 'post',
            params: {usercodename}
        });
    },


}
